// extracted by mini-css-extract-plugin
module.exports = {"new":"box_new__x14_b","wid":"box_wid__a8rwI","bt":"box_bt__3qfwF","thumbnail":"box_thumbnail__vcvfq"};